import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you provide website design services in Jodhpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer professional website design and development services for businesses and individuals in Jodhpur."
      }
    },
    {
      "@type": "Question",
      "name": "How much does it cost to build a website in Jodhpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The cost starts from ₹10,000 for basic websites. The final cost depends on your specific design, features, and page requirements."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. All our websites are designed to be fully responsive, ensuring compatibility with mobile phones, tablets, and desktops."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer SEO services with web development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our packages include on-page SEO like meta tags, schema markup, image optimization, and mobile performance enhancements."
      }
    },
    {
      "@type": "Question",
      "name": "Can I manage my website after it is completed?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we build websites using CMS platforms like WordPress, so you can easily manage and update your site without coding knowledge."
      }
    },
    {
      "@type": "Question",
      "name": "Do you build eCommerce websites in Jodhpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we specialize in creating eCommerce websites using WooCommerce, Shopify, and custom-built solutions with payment gateways."
      }
    },
    {
      "@type": "Question",
      "name": "What is the development time for a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We typically deliver basic websites within 5–7 days. More complex or eCommerce websites may take 2–4 weeks depending on features."
      }
    },
    {
      "@type": "Question",
      "name": "Can you assist with domain and hosting?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we help with domain registration, hosting setup, SSL installation, and email setup for your business."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer maintenance and support services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide ongoing maintenance packages that include content updates, bug fixes, backups, and performance monitoring."
      }
    },
    {
      "@type": "Question",
      "name": "How can I get started with your services in Jodhpur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Just contact us via our website or call us. We’ll understand your needs and begin your website project right away."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Jodhpur</title>
<meta name="description" content="Top website designer in Jodhpur. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="web design company in jodhpur, web development company in jodhpur, website design company in jodhpur, website development company in jodhpur, website designer in jodhpur, web design in jodhpur, website development in jodhpur, website developer in jodhpur, web developer in jodhpur, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Jodhpur" />
<meta property="og:description" content="Top Website Designer In Jodhpur. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Jodhpur" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-jodhpur"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Jodhpur" />
<meta name="twitter:description" content="Top website designer in Jodhpur. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-jodhpur" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer in Jodhpur</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Jodhpur</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Are you searching for a reliable website designer in Jodhpur who can bring your brand’s vision to life? I’m Pankaj, an experienced website designer dedicated to helping businesses and individuals establish a strong online presence with unique, responsive, and SEO-friendly websites.
<h3>Why Choose Pankaj for Website Design in Jodhpur?</h3>
<ol>
  <li><strong>Tailor-Made Designs to Suit Your Brand</strong>
I believe every brand has a story. Whether you need a corporate website, an e-commerce platform, a personal blog, or a portfolio, I work with you to create a design that reflects your brand identity and connects with your target audience.</li>
  <li><strong>SEO-Focused for Maximum Online Visibility</strong>
Your website should not only look great but also perform well on search engines. I incorporate essential SEO practices to help your website rank higher, making it easier for potential customers to find you online.</li>
  <li><strong>Full-Service Design and Development</strong>
From concept to completion, I provide a full range of website design services, including redesigns and e-commerce solutions. Using popular CMS platforms like WordPress, I make sure you can easily manage and update your website after launch.</li>
  <li><strong>Clear Communication and Continued Support</strong>
Transparency is a priority. I provide clear timelines, transparent pricing, and ongoing support to keep your website secure and optimized, ensuring it continues to serve your business effectively.</li>
</ol>
<h3>Services Offered</h3>
<ul>
  <li><strong>Custom Website Design &amp; Redesign</strong>
Unique, user-focused designs that prioritize your brand’s strengths and provide an exceptional user experience.</li>
  <li><strong>E-commerce Website Development</strong>
Secure and user-friendly e-commerce sites designed to drive sales and create a seamless shopping experience for your customers.</li>
  <li><strong>Corporate and Personal Websites</strong>
Professional websites that enhance your online presence and engage your target audience in Jodhpur and beyond.</li>
  <li><strong>SEO and Basic Digital Marketing</strong>
All websites are built with essential SEO features. For advanced digital marketing needs, I work with trusted experts to provide specialized support.</li>
</ul>
<h3>Let’s Create a Strong Online Presence Together!</h3>
Contact me today to discuss your project. Together, we’ll create a website that not only represents your brand in Jodhpur but also sets you apart in the digital world.
<h2>Frequently Asked Questions</h2>

<h4>What types of websites does Pankaj design in Jodhpur?</h4>
<p>Pankaj designs various websites, including corporate sites, e-commerce platforms, personal blogs, and portfolios. Each project is tailored to match the client’s brand identity and specific business goals.</p>

<h4>Why should I choose Pankaj as my website designer?</h4>
<p>Pankaj is an experienced designer who combines creativity with functionality. His websites are highly responsive, SEO-friendly, and crafted to provide an excellent user experience, ensuring your brand stands out online.</p>

<h4>Does Pankaj offer SEO services?</h4>
<p>Yes, Pankaj includes essential SEO best practices in each design to help your website rank better on search engines. For advanced SEO and digital marketing needs, he collaborates with trusted partners.</p>

<h4>How much does it cost to design a website?</h4>
<p>The cost of a website design project varies based on complexity, features, and requirements. Pankaj provides a personalized quote after discussing your specific needs, ensuring transparency from the start.</p>

<h4>Will I be able to update my website after it’s launched?</h4>
<p>Yes, Pankaj builds websites using user-friendly CMS platforms like WordPress, allowing clients to manage and update content easily. He also offers guidance and support to help you make updates confidently.</p>

<h4>Does Pankaj offer support after my website goes live?</h4>
<p>Yes, Pankaj provides ongoing maintenance and support services to ensure your website remains secure, updated, and optimized for performance. This includes troubleshooting, updates, and other necessary assistance.</p>

<h4>How long does a website design project take?</h4>
<p>The timeline for a website design project depends on its complexity. After discussing your project, Pankaj provides an estimated timeframe, which typically ranges from a few weeks to a couple of months.</p>

<h4>How can I contact Pankaj for website design services in Jodhpur?</h4>
<p>You can reach out to Pankaj through the contact form on this website or by using the provided contact information. He’s ready to discuss your project and create a website that aligns with your brand’s goals.</p>

          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
